<script>
import Vue from 'vue'
import VueYouTubeEmbed, { YouTubePlayer } from 'vue-youtube-embed'
import { cartComputed, authComputed } from '@state/helpers'
import VueContentLoading from 'vue-content-loading'

import _values from 'lodash/values'
import formatDate, { dateDiffInMinutes } from '@utils/format-date'
import parseStringToDate from '@utils/parse-string-to-date'
import { nlToBr } from '@utils'

import addDays from 'date-fns/addDays'
import getYear from 'date-fns/getYear'
import getMonth from 'date-fns/getMonth'

import Layout from '@layouts/main'
import ProductItemParams from '@components/ProductItemParams'
import SelectBookingDateSize from '@components/SelectBookingDateSize'
import BookingBanner from '@components/BookingBanner'
import ModalLogin from '@components/ModalLogin';
import BButton from "buefy/src/components/button/Button";
import parseStringToDateTime from '@utils/parse-string-to-date'

Vue.use(VueYouTubeEmbed, { global: false });

export default {
  page() {
    return {
      title: `${this.merchant.name} | ${this.product.name}`,
    }
  },
  components: {
    BButton,
    Layout,
    ProductItemParams,
    SelectBookingDateSize,
    VueContentLoading,
    YoutubeVideoPlayer: YouTubePlayer,
    BookingBanner,
    ModalLogin,

  },
  filters: {
    formatDate,
    nlToBr,
  },
  props: {
    merchant: {
      type: Object,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
    productParams: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      defaultAvatar: require('@assets/images/teacher_default.jpg'),
      defaultImage: require('@assets/images/activity_default.png'),
      selectedValue: {
        date: new Date(),
        groupSize: 1,
        time: {
          // alias: '',
        },
        params: {},
      },
      selectPrepaid: {},
      prepaidList: [],
      paramsSizeTotal: 0,
      paramsPriceTotal: 0,
      loadedDateTimesData: [], // 全部的dateTime
      loadedDateTimesDataGroup: [], // 紀錄loading過的年月 [YYYY-DD]
      loadingDateTimesData: false,
      isModalLoginActive: false,
      checkoutProcessing: false,
      payMethod: '',
      loginCallBack: null,
      showPreview: false,
      isOpenPrepaidSection: false,

      radioGroup: '',
      checkboxGroup: [''],
      texttt: '',
      locationHost: location.hostname
    }
  },
  computed: {
    ...cartComputed,
    ...authComputed,
    isShowPrepaid() {
      return this.merchant.showPrepaid
    },
    onlyShowParams() {
      const time = this.currentCart.time
        ? Object.keys(this.currentCart.time).length > 0
        : false;

      return time && Object.keys(this.currentCart.params).length === 0
    },
    availableDates() {
      const loadedDateTimesData = this.loadedDateTimesData[this.selectedValue.groupSize];
      return loadedDateTimesData
        ? loadedDateTimesData.map(({ date }) => date)
        : []
    },
    hasAvailableDates() {
      return this.loadedDateTimesData[this.selectedValue.groupSize]
        ? this.loadedDateTimesData[this.selectedValue.groupSize].length > 0
        : false
    },
    lastRowButtonNum() {
      const columns = window.width > '375px' ? 3 : 4;
      return Object.keys(this.displayTimes).length % columns
    },
    displayTimes() {
      const loadedDateTimesData = this.loadedDateTimesData[this.selectedValue.groupSize];


      const { times } = loadedDateTimesData
        ? loadedDateTimesData.find(
          ({ date }) => date === formatDate(this.selectedValue.date)
        ) || []
        : [];

      return _values(times) || []
    },
    maxGroupSize() {
      return +this.product.maxBookingSize || 20
    },
    minGroupSize() {
      return Math.min(
        ...Object.values(this.productParams).map((param) => param.size)
      )
    },
    invalidField() {
      const emptyField = Object.keys(this.selectedValue).find((field) =>
        typeof this.selectedValue[field] === 'object' &&
        typeof this.selectedValue[field].getMonth !== 'function'
          ? Object.keys(this.selectedValue[field]).length === 0
          : this.selectedValue[field] === ''
      );

      return emptyField || 'validated'
    },
    panelStateText() {
      const stateText = {
        groupSize: this.$t(
          'global.SELECT_PREFIX',
          { text: this.$t('global.GROUP_SIZE' /* 人數 */) } /* 請選擇{text} */
        ),
        time: this.$t(
          'global.SELECT_PREFIX',
          { text: this.$t('global.TIME' /* 時段 */) } /* 請選擇{text} */
        ),
        params: this.$t(
          'global.SELECT_PREFIX',
          {
            text: this.$t(`product.${this.product.type}.TEXT_PACKAGE_NAME`),
          } /* 請選擇{text} */
        ),
      };

      return (
        stateText[this.invalidField] ||
        this.$t(
          `product.${this.product.type}.TEXT_CHECKOUT` /* 前往下一步填寫預訂資訊 */
        )
      )
    },
    youtubeId() {
      const vidoeUrl = this.product.video;

      if(vidoeUrl) {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        const match = vidoeUrl.match(regExp);
        return (match && match[7].length === 11) ? match[7] : false;
      }
      return false;
    },
    displayRecommendPrepaids() {
      return this.product.recommendPrepaids.filter(recommend => {
        return Object.keys(this.selectedValue.params).every(alias => recommend.applicableParams.includes(alias))
          || Object.keys(this.selectedValue.params).length === 0
      })
    }
  },
  watch: {
    availableDates: 'updateDefaultSelectedDate', // ensure availableDates is ready
    'selectedValue.groupSize': 'changeSelectedGropSize',
    displayTimes: 'changeDisplayTimes',
    loggedIn(v) {
      if(!v) {
        this.togglePrepaidSection(false);
        this.payMethod = '';
      }
    }
  },
  mounted() {
    const cartIsEmpty = Object.keys(this.currentCart).length === 0;
    if (this.onlyShowParams) {
      this.updateSelectedValueFromCart()
    } else {
      if (!cartIsEmpty) {
        this.updateSelectedValueFromCart()
      }

      if(this.selectedValue.date) {
        const year = getYear(this.selectedValue.date);
        const month = getMonth(this.selectedValue.date) + 1;

        this.getCapacityOfProduct(year, month)
          .then(() => {
            const year = getYear(new Date(this.product.closestDate.replace(/-/g, '/')));
            const month = getMonth(new Date(this.product.closestDate.replace(/-/g, '/'))) + 1;

            this.getCapacityOfProduct(year, month);
          })
      }else {
        this.getCapacityOfProduct()
          .then(() => {
            const year = getYear(new Date(this.product.closestDate.replace(/-/g, '/')));
            const month = getMonth(new Date(this.product.closestDate.replace(/-/g, '/'))) + 1;

            this.getCapacityOfProduct(year, month);
          })

      }
    }

    // this.initObserver();
    if(this.loggedIn) {
      this.getPrepaidList();
    }
    this.onScroll();
    document.addEventListener("scroll", this.onScroll);
  },
  destroyed() {
    document.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    openLoginModal() {
      this.isModalLoginActive = true;
    },
    /*
    * 捲動
    * */
    onScroll() {
      if(document.getElementById('show-preview')) {
        this.showPreview = this.getScrollTop() > document.getElementById('show-preview').offsetTop
      }
    },
    /*
    * 取得ScrollTop
    * */
    getScrollTop() {
      let scrollTop = 0;

      if (typeof window.pageYOffset !== 'undefined') {
        scrollTop = window.pageYOffset;
      } else if (typeof document.compatMode !== 'undefined' && document.compatMode !== 'BackCompat') {
        scrollTop = document.documentElement.scrollTop;
      } else if (typeof document.body !== 'undefined') {
        scrollTop = document.body.scrollTop;
      }

      return scrollTop;
    },
    /* initObserver() {
      const target = document.getElementById('show-preview');

      if (target) {
        const observer = new IntersectionObserver((entries) => {
          this.showPreview = entries[0].isIntersecting
        });
        observer.observe(target)
      }
    }, */
    /*
    * 日期選擇器切換日期
    * */
    handleDateIsChanged() {
      this.handleScrollToSection('selectTime');
      // clear selected time to pretend previous time is already full
      this.selectedValue.time = {}
    },
    /*
    * 更新
    * */
    updateDefaultSelectedDate() {
      // ensure availableDates is not empty would causing errors
      if (this.availableDates.length > 0) {
        const selectedDate = formatDate(this.selectedValue.date); // default: today UTC -> '2019-06-13'
        const selectedIsAvailable = this.availableDates.includes(selectedDate);
        if (!selectedIsAvailable) {
          // force to update the date when selected date is not avaiable
          const [firstAvailableDate] = this.availableDates; // '2019-06-13'
          this.selectedValue = {
            ...this.selectedValue,
            date: parseStringToDate(firstAvailableDate),
          }
        }
      }
    },
    /*
    * 更新選擇值從購物車
    * */
    updateSelectedValueFromCart() {
      this.selectedValue = {
        ...this.selectedValue,
        ...this.currentCart,
        params: {},
      }
    },
    /*
    * 捲動到區塊
    * */
    handleScrollToSection(refName) {
      if (this.$refs[refName]) {
        this.$nextTick(() => {
          this.$refs[refName].scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          })
        })
      }
    },
    /*
    * 捲動到購買票券
    * */
    handleScrollToParams() {
      const refsMap = {
        'prepaid': 'selectPrepaidParams',
        'cash': 'selectParams',
      };

      const refs = refsMap[this.payMethod] || 'selectParams';

      if (this.$refs[refs]) {
        this.$nextTick(() => {
          this.$refs[refs].scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        })
      }
    },
    /*
    * 前往結帳頁
    * */
    handleToBookingCheckout(product) {
      if(!this.loggedIn) {
        this.openLoginModal();
        this.loginCallBack = () => {
          this.addCart(product)
        };
        return false;
      }

      if(this.paramsSizeTotal < this.selectedValue.groupSize) {
        this.$confirm(
          this.$t('global.LIGHT_BOX_ADD_CART_CONTENT', { qrsize: this.paramsSizeTotal, groupsize:
            this.selectedValue.groupSize }/* 人數: {}, 憑證數量: {} */),
          this.$t('global.LIGHT_BOX_ADD_CART_TITLE'
            /* 人數與憑證數量不符，請問是否繼續？ */),
          {
            distinguishCancelAndClose: false,
            dangerouslyUseHTMLString: true,
            confirmButtonText: this.$t('global.CONFIRM' /* 確認 */),
            cancelButtonText: this.$t('global.CANCEL' /* 取消 */),
            confirmButtonClass: 'button is-primary is-rounded',
            cancelButtonClass: 'button is-black is-rounded is-outlined',
          }).then(() => {
            this.addCart(product)
          });
      }else {
        this.addCart(product)
      }
    },
    /*
    * 加入購物車
    * */
    addCart(product) {
      this.checkoutProcessing = true;
      let cartParams = {};

      Object.keys(this.selectedValue.params).forEach(param => {
        cartParams[param] = {
          ...this.selectedValue.params[param],
          qty: this.selectedValue.params[param].selectQty,
        }
      });

      const cart = {
        ...this.selectedValue,
        params: cartParams,
        date: this.selectedValue.date,
        product,
        paramsSizeTotal: this.paramsSizeTotal,
        paramsPriceTotal: this.paramsPriceTotal,
        merchantAlias: this.merchant.alias,
        prepaid: this.payMethod === 'prepaid' ? this.selectPrepaid : undefined
      };

      const sessionCart = {
        merchantAlias: this.merchant.alias,
        productAlias: product.alias,
        inventoryAlias: this.selectedValue.time.alias,
        params: Object.keys(this.selectedValue.params).map((param) => {
          return {
            alias: this.selectedValue.params[param].alias,
            qty: this.selectedValue.params[param].selectQty,
          }
        }),
        prepaidOrderUuid: this.payMethod === 'prepaid' ? this.selectPrepaid.id : undefined
      };

      this.$store.dispatch('booking/updateSessionCart', sessionCart)
        .then((response) => {
          this.$router.push({
            name: 'booking-checkout',
            params: { productId: product.alias },
            query: {
              language: this.$route.query.language,
            },
          });

          this.$store.dispatch('booking/updateCart', cart);
        })
        .finally(() => {this.checkoutProcessing = false});
    },
    /*
    * 變更時段
    * */
    changeSelectedTime(value) {
      this.selectedValue.time = value
    },
    /*
    * 變更可用時段
    * */
    changeDisplayTimes() {
      const isOpenTime = this.displayTimes.filter(time => {
        return this.checkTimeIsAvailable(time)
      });

      if(isOpenTime.length === 1) {
        this.changeSelectedTime(isOpenTime[0])
      }
    },
    /*
    * 變更人數
    * */
    changeSelectedGropSize() {
      if (!this.onlyShowParams) {
        this.selectedValue.time = {};
        this.selectedValue.params = {};

        // this.loadedDateTimesData = [];
        // this.loadedDateTimesDataGroup = [];

        // 要判斷以選年月抓那年
        // 在loading完之後重置loadedDateTimesData loadedDateTimesDataGroup
        // 要加clear參數來清除loadedDateTimesData
        // loadedDateTimesDataGroup 一開始就要清掉

        this.loadingDateTimesData = true
      }

      const month = getMonth(this.selectedValue.date) + 1;
      const year = getYear(this.selectedValue.date);

      this.getCapacityOfProduct(year, month)
    },
    /*
    * 取得活動可用時段
    * */
    async getCapacityOfProduct(year = new Date().getFullYear(), month = new Date().getMonth() + 1) {
      const formatMonth = Number(month) < 10 ? `0${Number(month)}` : month;
      const monthLast = formatDate(addDays(new Date(year, month, 1), -1));
      const groupSize = this.selectedValue.groupSize;

      const isExpiredDate = new Date().getTime() - new Date(year, month - 1, 1).getTime() > 0;
      const isExpiredMonth = new Date().getFullYear() >= year && new Date().getMonth() + 1 > month;

      const date = isExpiredDate ? new Date().getDate() : '01';
      const fmDate = Number(date) < 10 ? `0${Number(date)}` : date;

      if(isExpiredMonth) {
        this.$set(this.loadedDateTimesData, groupSize, []);
        console.log(this.loadedDateTimesData)
      }

      if(isExpiredMonth || this.loadedDateTimesDataGroup.includes(`${year}-${formatMonth}&groupSize:${groupSize}`)) {
        this.loadingDateTimesData = false;
      } else {
        await this.$store
          .dispatch('merchant/fetchProductCapacity', {
            merchantAlias: this.merchant.alias,
            productAlias: this.product.alias,
            groupSize: groupSize,
            startDate: `${year}-${formatMonth}-${fmDate}`,
            endDate: monthLast
          })
          .then((dateTimes) => {
            this.loadedDateTimesDataGroup.push(`${year}-${formatMonth}&groupSize:${groupSize}`);
            this.loadingDateTimesData = false;
            if(!this.loadedDateTimesData[groupSize]) {
              this.$set(this.loadedDateTimesData, groupSize, []);
              this.$set(this.loadedDateTimesData, groupSize, dateTimes);
            }else {
              dateTimes.forEach(item => {
                this.loadedDateTimesData[groupSize].push(item);
              })
            }
          });

        return true
      }
    },
    /*
    * 檢查時間可用
    * */
    checkTimeIsAvailable(time) {
      const checkTimeIsPast = (dateTime) => {
        const diffFromNow = dateDiffInMinutes(
          formatDate(new Date(), 'dateTimeSecond'),
          dateTime
        );
        return diffFromNow < 0
      };

      return (
        time.capacity === 'open' &&
        !checkTimeIsPast(
          `${formatDate(this.selectedValue.date)} ${time.startTime}:00`
        )
      )
    },
    /*
    * 切換日期選擇器年月
    * */
    handlePageIsChanged(page) {
      const year = page.year;
      const month = page.month;

      this.getCapacityOfProduct(year, month)
    },
    /*
    * 切換我的預付方案區塊
    * */
    togglePrepaidSection(type) {
      if(type) {
        if(!this.loggedIn) {
          this.openLoginModal();

          this.loginCallBack = () => {
            this.getPrepaidList(() => {
              this.isOpenPrepaidSection = type;
              this.handleScrollToSection('selectPrepaidParams');
            });
          };
        }else {
          this.isOpenPrepaidSection = type;
        }
      }else {
        this.isOpenPrepaidSection = type;
      }
    },
    /*
    * 設定付款方式 { type: [cash, prepaid] }
    * */
    setPayMethod(type) {
      this.payMethod = type;
    },
    /*
    * 取得預付方案列表
    * */
    async getPrepaidList(callback) {
      await this.$store
        .dispatch('booking/fetchPrepaidOrderAvailable', {
          productAlias: this.$route.params.productId
        })
        .then((response) => {
          this.prepaidList = response.items.map(prepaid => {
            return {
              text:
                `${prepaid.prepaidTitle} (${this.$t('global.REMAINDER_NUMBER',
                  { size: prepaid.times - prepaid.used }/* 剩餘 {size} 次 */)} )`,
              value: prepaid,
            }
          });

          if(this.prepaidList.length > 0) {
            this.selectPrepaid = this.prepaidList[0].value
          }

          if(callback){
            callback();
          }
        });
    },
    /*
    * 切換方案
    * */
    onInputPrepaid(value) {
      this.payMethod = '';
      this.selectedValue.params = {};
    },
    hasRequired(extrafields) {
      return extrafields.some(item => {
        return item.required
      })
    },
    handleToPrepaid(prepaidItem) {
      this.$confirm(
        this.$t('global.LIGHT_BOX_TO_BUY_PREPAID_CONTENT' /* 即將跳轉至購買預付方案，確認離開此頁面？ */),
        this.$t('global.LIGHT_BOX_TO_BUY_PREPAID_TITLE' /* 您將離開此頁面 */),
        {
          distinguishCancelAndClose: false,
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('global.CONFIRM' /* 確認 */),
          cancelButtonText: this.$t('global.CANCEL' /* 取消 */),
          confirmButtonClass: 'button is-primary is-rounded',
          cancelButtonClass: 'button is-black is-rounded is-outlined',
        }).then(() => {
          this.$router.push({
            name: 'booking-prepaid-item',
            params: {
              merchantAlias: this.$route.params.merchantAlias,
              prepaidAlias: prepaidItem.alias,
            },
            query: {
              language: this.$route.query.language,
            },
          })
        });
    }
  },
}
</script>
<template>
  <Layout>
    <div class="booking-container">
      <BookingBanner v-if="!onlyShowParams" :merchant="merchant"></BookingBanner>
      <div v-if="!onlyShowParams" class="booking-section">
        <div class="level subsection is-small">
          <h4 class="booking-section__title">{{ product.name }}</h4>
        </div>

        <div v-if="product.image" class="hero">
          <figure>
            <img :src="product.image" :alt="product.name" :class="$style.banner" class="is-cover" />
          </figure>
        </div>
        <div v-if="product.description" class="subsection">
          <div
            class="subsection__title"
          >{{ $t(`product.${product.type}.TITLE_DETAILS`/* 商品內容 */) }}</div>
          <div class="is-text-content" v-html="$options.filters.nlToBr(product.description)"></div>
        </div>
        <div v-if="product.staffs.length > 0" class="subsection">
          <div
            class="subsection__title"
          >{{ $t(`product.${product.type}.TITLE_HOSTS_INTRODUCTION`/* 商品相關人介紹 */) }}</div>
          <div
            v-for="(host, $index) in product.staffs"
            :key="$index"
            class="columns"
            :class="$style.host"
          >
            <div class="column is-5" :class="$style['host-left']">
              <div>
                <picture :class="$style['host-avatar']">
                  <BaseImage :src="host.avatar" :error-src="defaultAvatar" class-name="is-cover" />
                </picture>
              </div>
              <div :class="$style['host-name__wrapper']">
                <div class="is-size-6 has-text-weight-medium" v-text="host.hostTitle"></div>
                <div class="is-size-5" :class="$style['host-name']">{{ host.name }}</div>
                <div v-text="host.title"></div>
              </div>
            </div>
            <div
              class="is-text-content column"
              :class="$style['host-intro']"
              v-html="$options.filters.nlToBr(host.description)"
            ></div>
          </div>
        </div>
        <div v-if="product.address" class="subsection">
          <div class="subsection__title">{{ $t('product.TITLE_LOCATION'/* 地點 */) }}</div>
          <a
            :href="`https://www.google.com/maps/search/?api=1&query=${product.address}`"
            target="_blank"
          >
            {{ product.locationName || product.address }}
            <BaseIcon name="external-link-alt" :class-name="'icon is-right is-box'" />
          </a>
        </div>
        <div v-if="youtubeId" class="subsection">
          <div class="subsection__title">{{ $t('product.TITLE_VIDEO'/* 影音 */) }}</div>
          <YoutubeVideoPlayer
            :class="$style.video"
            :video-id="youtubeId"
            player-width="100%"
            player-height="300"
          />
        </div>
        <template v-if="product.orderExtrafields.byProduct">
          <template v-for="(extrafield, index) in product.orderExtrafields.byProduct">
            <div v-if="extrafield.value" :key="index" class="subsection">
              <div class="subsection__title">{{extrafield.title}}</div>
              <p v-html="$options.filters.nlToBr(extrafield.value)"></p>
            </div>
          </template>
        </template>
        <div v-if="product.notice" class="subsection">
          <div class="subsection__title">{{ $t('product.TITLE_NOTICE'/* 注意事項 */) }}</div>
          <p v-html="$options.filters.nlToBr(product.notice)"></p>
        </div>
      </div>
      <div v-if="!onlyShowParams" id="show-preview" class="booking-section">
        <div class="level subsection is-tab-style">
          <h4
            class="level-left booking-section__title"
          >{{ $t(`product.${product.type}.TITLE_INFORMATION`/* 資訊 */) }}</h4>
          <div class="level-right">
            <a
              v-if="merchant.phoneNumber"
              :href="`tel:${merchant.phoneNumber}`"
            >
              <b-button class="is-link-grey-light is-outlined">
                <span class="circle-icon-style file-icon">
                  <BaseIcon name="phone-volume"  />
                </span>
                {{ $t('global.CONTACT_MERCHANT'/*聯絡商家*/) }}
              </b-button>
            </a>
          </div>
        </div>
        <div ref="selectDateSize" class="subsection">
          <div
            class="subsection__title"
          >{{ $t(`product.${product.type}.TITLE_DATE_AND_GROUP_SIZE`/*預訂日期與人數*/) }}</div>
          <SelectBookingDateSize
            :date.sync="selectedValue.date"
            :size.sync="selectedValue.groupSize"
            :available-dates="availableDates"
            :max-size="maxGroupSize"
            @select-date="handleDateIsChanged"
            @change-page="handlePageIsChanged"
          />
        </div>
        <div ref="selectTime" class="subsection">
          <div class="subsection__title">{{ $t(`product.${product.type}.TITLE_TIME`/*時段*/) }}</div>
          <p
            v-if="displayTimes.length > 0"
            class="subsection__helptext has-text-grey-light"
          >*{{ $t(`product.${product.type}.TIME_HELP_TEXT`/* 灰色表示該時間名額已滿，恕無法提供預訂 */) }}</p>
          <template v-if="hasAvailableDates">
            <div
              v-if="displayTimes.length > 0"
              :class="[$style['timeButtons'], `is-last-${lastRowButtonNum}`]"
            >
              <div
                v-for="(value) in displayTimes"
                :key="value['alias']"
                :class="$style['timeButtons__cell']"
              >
                <button
                  :class="[checkTimeIsAvailable(value) ? 'is-primary' :  'is-static' ,
                    { 'is-outlined': value['alias'] !== selectedValue.time['alias'] }]"
                  class="button is-rounded is-fullwidth"
                  @click="changeSelectedTime(value)"
                >{{ value['startTime'] }}</button>
              </div>
            </div>
          </template>
          <VueContentLoading
            v-else-if="loadingDateTimesData"
            :width="464"
            :height="70"
            :speed="3"
          >
            <rect x="0" y="0" rx="14" ry="14" width="110" height="28" />
            <rect x="118" y="0" rx="14" ry="14" width="110" height="28" />
            <rect x="236" y="0" rx="14" ry="14" width="110" height="28" />
            <rect x="354" y="0" rx="14" ry="14" width="110" height="28" />
            <rect x="0" y="40" rx="14" ry="14" width="110" height="28" />
            <rect x="118" y="40" rx="14" ry="14" width="110" height="28" />
            <rect x="236" y="40" rx="14" ry="14" width="110" height="28" />
            <rect x="354" y="40" rx="14" ry="14" width="110" height="28" />
          </VueContentLoading>
          <div v-else>{{ $t(`product.${product.type}.TIME_NO_AVAILABLE`/* 無時段可供訂購，請選擇其他日期 */) }}</div>
        </div>
      </div>
      <div v-if="isShowPrepaid" ref="selectPrepaidParams"
           class="booking-section">
        <div>
          <div @click="togglePrepaidSection(!isOpenPrepaidSection)" class="level subsection  is-button-style is-small">
            <h4
              class="level-left booking-section__title">
              <BaseIcon v-if="isOpenPrepaidSection" name="angle-down" class-name="fa-fw" style="margin-right: 0.5rem"/>
              <BaseIcon v-else name="angle-right" class-name="fa-fw" style="margin-right: 0.5rem"/>
              {{ $t('global.USE_PREPAID'/*使用我的方案*/) }}
              <span v-if="!loggedIn" class="has-text-grey-light">({{ $t('global.NEED_LOGIN'/*需驗證*/) }})</span>
            </h4>
            <div class="level-right">

            </div>
          </div>
          <div v-if="isOpenPrepaidSection" class="subsection" :class="{ 'is-disabled': payMethod === 'cash' }">
            <template v-if="prepaidList.length > 0">
              <div class="subsection__title">選擇預付方案</div>
              <b-field :class="$style['field']" class="is-style-shadow">
                <b-select
                  v-model="selectPrepaid"
                  :class="$style['field-control']"
                  placeholder="選擇預付方案"
                  expanded
                  rounded
                  class="is-split-mobile"
                  @input="onInputPrepaid"
                >
                  <option
                    v-for="(prepaidItem, index) in prepaidList"
                    :key="index"
                    :value="prepaidItem.value"
                  >{{prepaidItem.text}}</option>
                </b-select>
              </b-field>
            </template>
            <template v-else>
              <div class="subsection__title">{{ $t('global.SELECT_PREPAID_NULL_TITLE'/*未有可用的預付方案*/) }}</div>
              <p class="subsection__helptext has-text-grey-light"
              >{{ $t('global.SELECT_PREPAID_NULL_CONTENT'/*已查詢您的購買紀錄，未有預付方案可供此活動使用*/) }}</p>
            </template>
          </div>
          <div v-if="isOpenPrepaidSection && prepaidList.length > 0"
               class="subsection"
               :class="{ 'is-disabled': payMethod === 'cash' }">
            <div class="subsection__title">{{ $t(`product.${product.type}.TITLE_PACKAGE`/* 選取商品方案 */) }}</div>
            <!--預付抵用-->
            <ProductItemParams
              ref="product-params"
              :data="selectPrepaid.prices"
              :value.sync="selectedValue.params"
              :value-size-total.sync="paramsSizeTotal"
              :value-price-total.sync="paramsPriceTotal"
              :max-value="selectedValue.groupSize"
              :select-prepaid="selectPrepaid"
              :pay-method-type="'prepaid'"
              :pay-method="payMethod"
              @setPayMethod="setPayMethod"
            />
          </div>
        </div>
      </div>
      <div
           ref="selectParams"
           class="booking-section">
        <div class="level subsection is-small">
          <div class="level-left">
            <h4
              class="booking-section__title"
            >{{ $t(`product.${product.type}.TITLE_PACKAGE`/* 選取商品方案 */) }}</h4>
          </div>
          <div class="level-right">
            <b-button
              v-if="displayRecommendPrepaids.length > 0 && isShowPrepaid"
              class="is-link-primary"
              @click="handleScrollToSection('solutionList')"
            >
              {{ $t('global.PREPAID_SOLUTION_BUTTON'/*優惠方案推薦*/)}}
            </b-button>
          </div>
        </div>
        <div class="subsection" :class="{ 'is-disabled': payMethod === 'prepaid' || (!hasAvailableDates && !onlyShowParams) }">
          <!--一般付款-->
          <ProductItemParams
            ref="product-params"
            :data="productParams"
            :value.sync="selectedValue.params"
            :value-size-total.sync="paramsSizeTotal"
            :value-price-total.sync="paramsPriceTotal"
            :max-value="selectedValue.groupSize"
            :select-prepaid="selectPrepaid"
            :pay-method-type="'cash'"
            :pay-method="payMethod"
            @setPayMethod="setPayMethod"
          />
        </div>
      </div>
      <div v-if="displayRecommendPrepaids.length > 0 && isShowPrepaid" class="booking-section--outside">
        <h4 class="is-size-5 has-text-weight-medium">
          {{ $t('global.PREPAID_SOLUTION'/*推薦方案*/) }}
        </h4>
        <!--<div style="color: #2F8D96">({{ $t('global.PREPAID_SOLUTION_TIP'/*預付方案不限本人使用，每次使用僅限抵用單人計次的付費項目，購買前請多加留意。*/)
          }})</div>-->
      </div>
      <div v-if="isShowPrepaid" ref="solutionList" :class="$style.solutionList">
        <div
          v-for="(prepaidItem, index) in displayRecommendPrepaids"
          :key="index"
          :class="$style.solutionItem"
          @click="handleToPrepaid(prepaidItem)"
        >
          <div :class="$style.solutionInner">
            <div :class="$style['solutionImageBox']">
              <picture>
                <BaseImage :class="$style['solutionImage']" :src="prepaidItem.introimage" :error-src="defaultImage"
                           class-name="is-cover" />
              </picture>
              <div :class="$style.styleBlockItem">
                <span class="has-text-white">{{ $t('global.PREPAID_TOTAL_DEDUCT'/*總抵用次數*/) }}</span>
                <h4 class="is-size-5 has-text-white  has-text-weight-medium">{{prepaidItem.times}}</h4>
              </div>
            </div>
            <h4 class="is-size-5 has-text-weight-medium" style="margin: 0.5rem 0">{{prepaidItem.name}}</h4>
            <h5 class="has-text-grey-light" style="margin-bottom: 0.75rem">{{prepaidItem.introtext}}</h5>
            <p :class="$style['solutionContent']" v-html="$options.filters.nlToBr(prepaidItem.slogan)"></p>
            <div class="level">
              <div class="level-left">
                <div>
                  <div
                    v-if="prepaidItem.basePrice > prepaidItem.price"
                    class="has-text-grey-light"
                    style="margin-bottom: 0.25rem;text-decoration: line-through;"
                  >
                    ${{prepaidItem.basePrice}}
                  </div>
                  <div class="has-text-primary is-size-4 has-text-weight-medium">
                    ${{prepaidItem.price}}
                  </div>
                </div>
              </div>
              <div class="level-right">
                <b-button
                  v-if="prepaidItem.infinity || prepaidItem.qty < prepaidItem.inventory"
                  type="is-primary"
                  class="is-mobile-fullwidth"
                  outlined
                  rounded
                  @click.prevent.stop="handleToPrepaid(prepaidItem)"
                >
                  {{$t('global.BUY_NOW')/*立即購買*/}}
                </b-button>
                <b-button
                  v-else
                  type="is-static"
                  class="is-mobile-fullwidth"
                  outlined
                  rounded
                  @click.prevent.stop="handleToPrepaid(prepaidItem)"
                >
                  {{ $t(`product.prepaid.BUTTON_SOLD_OUT` /* 已售完 */) }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="$style['nextStepSection']">
      <transition name="fixed-preview" appear>
        <div :class="$style.preview">
          <div class="booking-container">
            <div class="level">
              <b-button
                v-if="!showPreview && invalidField === 'time'"
                type="is-primary is-rounded is-fullwidth"
                class="fix-width-200"
                @click="handleScrollToParams()"
              >{{ $t(`product.${product.type}.BUTTON_BOOK_NOW`/* 立即預訂 */) }}</b-button>
              <div v-else class="level-left">
                <div class="buttons">
                  <b-button
                    type="is-black is-rounded"
                    outlined
                    @click="handleScrollToSection('selectDateSize')"
                  >{{ selectedValue.date | formatDate('dateWeekDay') }}</b-button>
                  <b-button
                    v-show="selectedValue.groupSize"
                    type="is-black is-rounded"
                    outlined
                    @click="handleScrollToSection('selectDateSize')"
                  >{{ selectedValue.groupSize }} {{$tc('global.GUEST'/* 位 */, selectedValue.groupSize )}}</b-button>
                  <b-button
                    v-show="selectedValue.time['startTime']"
                    type="is-black is-rounded"
                    outlined
                    @click="handleScrollToSection('selectTime')"
                  >{{ selectedValue.time['startTime'] }}</b-button>
                  <template
                    v-for="(param, alias) in selectedValue.params"
                    v-show="selectedValue.params"
                  >
                    <b-button
                      v-show="param.selectQty !== 0"
                      :key="alias"
                      type="is-black is-rounded"
                      outlined
                      @click="handleScrollToSection('selectParams')"
                    >{{ ` ${param.selectQty} x ${param.name}` }}</b-button>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="fixed-panel" appear>
        <div v-show="showPreview || invalidField !== 'time'" :class="$style.panel">
          <div class="booking-container">
            <div class="level">
              <div class="level-left" :class="$style['panel-left']">
                <div class="has-text-primary">{{panelStateText}}</div>
                <div
                  v-if="paramsSizeTotal"
                  :class="$style['panel-left__total']"
                >
                  <span v-if="payMethod === 'prepaid'">
                    {{ $t('global.TOTAL_ADMISSION_AND_PREPAID_AND_TOTAL_DEDUCT', { size: paramsSizeTotal, prepaid:
                    selectPrepaid.prepaidTitle, num: paramsSizeTotal }/*共{size}枚憑證，使用{prepaid}，總計抵用 ${num}次 */) }}
                  </span>
                  <span v-else>
                    {{ $t('global.TOTAL_ADMISSION_AND_TOTAL_PRICE', { size: paramsSizeTotal, price: paramsPriceTotal }/*共{size}枚憑證，總計 ${price} */) }}
                  </span>
                </div>
              </div>
              <div class="level-right">
                <b-button
                  :disabled="invalidField !== 'validated' || checkoutProcessing"
                  :loading="checkoutProcessing"
                  :type="'is-primary'"
                  rounded
                  class="fix-width-200 is-mobile-fullwidth"
                  @click="handleToBookingCheckout( product )"
                >{{ $t(`product.${product.type}.BUTTON_BOOK_NOW`/* 立即預訂 */) }}</b-button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <b-modal
      custom-class="is-login-style"
      :active.sync="isModalLoginActive"
      :width="370"
      :can-cancel="['escape','outside']">
      <ModalLogin @close="isModalLoginActive = false" @login="loginCallBack"/>
    </b-modal>
    <!--<b-loading :is-full-page="true" :active.sync="checkoutProcessing"></b-loading>-->
  </Layout>
</template>
<style lang="scss" module>
.selectParamsSection {
  justify-content: center;
  min-height: 65vh;
}
.nextStepSection {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 6;
  width: 100%;

  @include mobile {
    :global(.level) {
      // display: inline-flex;
    }
  }

  .preview {
    padding: 10px;
    background: white;
    box-shadow: rgba(145, 145, 145, 0.5) 0 5px 10px 5px;
    @include mobile {
      // overflow-x: scroll;
    }
  }
  .panel {
    @extend %typography-medium;

    padding: 15px 18px;
    overflow-x: scroll;
    color: $grey;
    background: white;
    border-top: 1px solid $color-border-base;
    &-left {
      flex-grow: 1;
      justify-content: space-between;
      &__total {
        margin-right: 1.5rem;
      }
    }
  }
}
.timeButtons {
  display: flex;
  flex-wrap: wrap;
  margin-right: -10px;
  margin-left: -10px;
  &__cell {
    flex: 0 0 25%;
    max-width: 25%;
    height: $size-button-height;
    padding: 0 10px;
    margin-bottom: 20px;

    @include mobile {
      flex: 0 0 33%;
      max-width: 33%;
    }
  }
}
.banner {
  width: 100%;
  height: 300px;
}
.host {
  align-items: center;
  padding: 15px 0;
  &:not(:last-child) {
    border-bottom: 1px solid $color-border-base;
  }
  & + .host {
    padding: 15px 0;
  }
  &-left {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  &-avatar {
    position: relative;
    box-sizing: content-box;
    display: flex;
    width: 96px;
    height: 96px;
    overflow: hidden;
    cursor: pointer;
    background: $grey-lighter;
    border-radius: 100%;
  }
  &-intro {
    display: flex;
  }

  &-name {
    margin-top: 0.5rem;
    margin-bottom: 0.25rem;
    line-height: 1.3em;
    &__wrapper {
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;
      padding-left: 1rem;
    }
  }
}
.video iframe {
  height: 300px;
}

.field {
  @include mobile {
    flex-wrap: wrap;
  }
  &-control {
    @include desktop {
      flex: 1;
    }

    @include mobile {
      flex-basis: 100%;
    }
    &:not(:last-child) {
      @include mobile {
        margin-bottom: 0.5rem;
      }
    }

    :global {
      .button {
        justify-content: left;
        border-width: 1px;
        border-color: $color-border-base;
      }
    }
  }
}
.solutionImageBox {
  position: relative;
}
.styleBlockItem {
  background: rgba($color-primary, 0.85);
  color: #fff;
  border-radius: 5px;
  padding: 0.25rem 0.5rem;
  text-align: right;
  position: absolute;
  right: 1rem;
  bottom: 1rem;
}

.solutionList {
  display: flex;
  flex-wrap: wrap;
  margin-right: -7px;
  margin-left: -7px;
  .solutionItem {
    position: relative;
    width: 100%;
    padding-right: 7px;
    padding-left: 7px;
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
    cursor: pointer;
    @include mobile {
      flex: 0 0 100%;
      max-width: 100%;
    }
    .solutionInner {
      padding: 1.5rem;
      margin-bottom: 15px;
      background: white;
      border-radius: 12px;
      box-shadow: 0 0 25px 0 rgba(178, 180, 181, 0.1);
      &:hover {
        box-shadow: 0 0 60px 0 rgba(178, 180, 181, 0.4);
        transition: box-shadow 0.3s;
      }
      .solutionImage {
        height: 150px;
        width: 100%;
        overflow: hidden;
        background: $grey-lighter no-repeat;
        border-radius: $size-image-border-radius;
        position: relative;
        background-size: cover;
        @include mobile {
          height: 200px;
        }
      }
      .solutionContent {
        margin-bottom: 1.5rem;
        height: 4.2em;
        text-overflow: ellipsis;
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: 3;
        /* autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
      }
    }
  }
}

.isRequired {
  :global(.label::after) {
    margin-left: 4px;
    color: $color-danger;
    content: '*';
  }
}
</style>
